const MarkdownIt = require("markdown-it");
const texmath = require("markdown-it-texmath");
const katex = require("katex");
const { disableEmailAutolink } = require("./notesDisplaySafe.js");

/**
 * Apply target=_blank to markdown links (same behavior as markdownTargetBlankLinks).
 * @param {import("markdown-it")} md
 */
function applyBlankLinks(md) {
  const defaultRender =
    md.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const aIndex = tokens[idx].attrIndex("target");
    if (aIndex < 0) {
      tokens[idx].attrPush(["target", "_blank"]);
    } else {
      tokens[idx].attrs[aIndex][1] = "_blank";
    }
    return defaultRender(tokens, idx, options, env, self);
  };
}

/**
 * Shared markdown-it for Notes timeline + focus preview (math via KaTeX).
 * Delimiters: $...$ / $$...$$ and \\(...\\) / \\[...\\].
 * @returns {import("markdown-it")}
 */
function createNotesMarkdown() {
  const md = new MarkdownIt({ breaks: true, linkify: true });
  disableEmailAutolink(md);
  applyBlankLinks(md);
  md.use(texmath, {
    engine: katex,
    delimiters: ["dollars", "brackets"],
    katexOptions: { throwOnError: false, errorColor: "#cc0000" },
  });
  return md;
}

module.exports = {
  createNotesMarkdown,
  applyBlankLinks,
};
